import { type RouteRecordRaw } from 'vue-router'

import { useNotificationsStore } from '@/pages/notifications/notifications.store'

import { useApplicationCfgStore } from '../applicationCfg/applicationCfg.store'

export const NotificationsRouter: RouteRecordRaw[] = [
  {
    path: '/notifications',
    component: async () => import('./Notifications.vue'),
    async beforeEnter() {
      await useApplicationCfgStore.getState().loadApplicationCfg()
    },
  },
  {
    path: '/notifications/import',
    component: async () => import('./NotificationsImport.vue'),
    async beforeEnter() {
      useNotificationsStore.getState().resetImport()
      await useNotificationsStore.getState().list()
    },
  },
]
